import { IDocumentCategory } from "us.collection.documents/interfaces";
import * as Yup from "yup";

export default (existingCategories: Array<IDocumentCategory>) => {
  return Yup.object().shape({
    documentCategory: Yup.string()
    .required("US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD")
    .notOneOf(
      existingCategories.map(category => category.documentCategory),
       "US.COLLECTION.VALIDATIONS:REQUIRED.CATEGORY_NAME_ALREADY_EXISTS"
    ),
  });
};
